module.exports = __webpack_public_path__ + "img/posterbox.9d1d79b2.png";